import React, { useContext, useEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate
} from "react-router-dom";
import { ChatOverlay } from './ChatOverlay';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Ad1 } from './Ad1';
import { Ad1Chat } from './Ad1Chat';
import { Yoni } from './Yoni';
import { ChatsAsPage } from './Chats/ChatsAsPage';
import { WithDOB } from './Design';
import { PentaView } from './Edu/PentaView';
import { YoniPentaView } from './Edu/YoniPentaView';
import { Import } from './Import';
import { Layout } from './Layout';
import { WithPenta } from './Penta/WithPenta';
import { WithPublicData } from './Public';
import { TestMain } from './Test/TestMain';
import { GroupLayout } from './UiKit/GroupLayout';
import Page404 from './UiKit/Page404';
import { PreloaderHD } from './UiKit/PreloaderHD';
import { Thumbnail } from './UiKit/Thumbnail';
import { VideoPop } from './VideoPop';
import { WithGroup } from './WithGroup';
import { AdminTexts } from './Admin/AdminTexts';
import { AdminVideos } from './Admin/AdminVideos';
import { AdminUsers } from './Admin/AdminUsers';
import { AdminSkynet } from './Admin/AdminSkynet';
import { Celebs, CelebsData } from './Lists/Celebs';
import { CelebsLayout } from './CelebsLayout';
import { AdminAPI } from './Admin/AdminAPI';
import { AdminChannels } from './Admin/AdminChannels';
import { AdminFlags } from './Admin/AdminFlags';
import { AdminNetwork } from './Admin/AdminNetwork';
import { LangContext } from '../contexts/langContext';
import { clearReturnAfterLogin, peekReturnAfterLogin, registerNavigate } from './utilsSocial';
import { CloudsPreview } from './Lists/PeopleMap/CloudsPreview';
import { InAppBrowserGate } from './InAppBrowserGate';
import { AuthModal } from './AuthModal';

const Bodygraph3DPreview = React.lazy(() =>
  import('./UiKit/Bodygraph3D/Bodygraph3DPreview')
);

// import { Rectificate } from './Rectification/Rectificate';

const NavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerNavigate(navigate);
    return () => registerNavigate(null);
  }, [navigate]);

  return null;
};

// Language redirect component for React Router v6
const LanguageRedirect = ({ lang }) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const navigate = useNavigate();
  
  useEffect(() => {
    context.setLanguage(lang);
    navigate('/intro', { replace: true });
  }, [lang, navigate, context]);
  
  return null;
};

// After Auth0, backend always lands on `/`. Prefer a saved deep-link (e.g. /chats/:id).
const HomeRedirect = () => {
  const context = useContext(SocialContext);
  const returnTo = peekReturnAfterLogin();

  useEffect(() => {
    if (Boolean(context.me) && context.me !== 0 && returnTo) {
      clearReturnAfterLogin();
    }
  }, [context.me, returnTo]);

  if (!context.meReady) {
    return null;
  }

  if (Boolean(context.me) && context.me !== 0) {
    if (returnTo) {
      return <Navigate to={returnTo} replace />;
    }
    return <Navigate to={`/u/${context.me.user.token}`} replace />;
  }

  if (Boolean(context.me) || context.me === 0) {
    return <Navigate to="/intro" replace />;
  }

  return null;
};

const loggedInMe = (context) => (
  Boolean(context.meReady)
  && Boolean(context.me)
  && context.me !== 0
  && typeof context.me === 'object'
  && Boolean(context.me.user?.token)
);

export function RoutesMain(props) {

  const context = { ...useContext(SocialContext), ...useContext(StateContext) };

  // define a function that sets min-height of my-element to window.innerHeight:



  return (
    <BrowserRouter>
      <NavigationBridge />







        <Routes>


          <Route
            path={'/ppp'}
            element={
              <>
                <PreloaderHD />
              </>
            }
          />

          <Route
            path={'/en'}
            element={<LanguageRedirect lang="en" />}
          />
          <Route
            path={'/ru'}
            element={<LanguageRedirect lang="ru" />}
          />

          <Route
            path={'/'}
            element={<HomeRedirect />}
          />

          <Route
            path={'/intro'}
            element={
              <>
                {loggedInMe(context) && <Navigate to={`/u/${context.me.user.token}`} />}
                <Ad1 />
              </>
            }
          />

          <Route
            path={'/login2'}
            element={
              <>
                {loggedInMe(context) && <Navigate to={`/u/${context.me.user.token}`} />}
                <Ad1 />
              </>
            }
          />


          <Route
            path={'/test'}
            element={<>

              <TestMain />

            </>}
          />


          {/* TEMP: clouds preview for tuning the intro overlay */}
          <Route
            path={'/clouds'}
            element={<CloudsPreview />}
          />

          {/* TEMP: preview for tuning the 3D bodygraph and the composite field */}
          <Route
            path={'/body3d'}
            element={
              <React.Suspense fallback={null}>
                <Bodygraph3DPreview />
              </React.Suspense>
            }
          />


          <Route
            path={'/yoni'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/'}
            element={<>
              <Yoni />
            </>}
          />

          {/* Static /yoni/p/* before /yoni/:useravatarId */}
          <Route path='/yoni/p/:pentaId/*'>
            <Route
              index
              element={<>
                <Layout>
                  <WithPenta mode="yoni">
                    <YoniPentaView />
                  </WithPenta>
                </Layout>
              </>}
            />
            <Route path='study/:what' element={
              <Layout>
                <WithPenta mode="yoni">
                  <YoniPentaView />
                </WithPenta>
              </Layout>
            } />
          </Route>

          <Route
            path={'/yoni/:useravatarId'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/study/:what'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/study/:what/'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/info'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/followers'}
            element={<>
              <Yoni />
            </>}
          />
          <Route
            path={'/yoni/:useravatarId/followings'}
            element={<>
              <Yoni />
            </>}
          />



          <Route
            path={'/import'}
            element={<>

              <Import />

            </>}
          />

          <Route
            path={'/admin'}
            element={<>
              <AdminUsers />
            </>}
          />

          <Route
            path={'/admin/network'}
            element={<>
              <AdminNetwork />
            </>}
          />

          <Route
            path={'/admin/skynet'}
            element={<>
              <AdminSkynet />
            </>}
          />

          <Route
            path={'/admin/texts'}
            element={<>
              <AdminTexts />
            </>}
          />

          <Route
            path={'/admin/videos'}
            element={<>
              <AdminVideos />
            </>}
          />

          <Route
            path={'/admin/api'}
            element={<>
              <AdminAPI />
            </>}
          />

          <Route
            path={'/admin/channels'}
            element={<>
              <AdminChannels />
            </>}
          />

          <Route
            path={'/admin/flags'}
            element={<>
              <AdminFlags />
            </>}
          />

          {/* клик по каналу уводит на .../study/channel:id — остаёмся на той же странице */}
          <Route
            path={'/admin/channels/study/:what'}
            element={<>
              <AdminChannels />
            </>}
          />



          <Route path='/p/:pentaId/*'>
            <Route
              index
              element={<>
                <Layout>
                  <WithPenta>
                    <PentaView />
                  </WithPenta>
                </Layout>
              </>}
            />

            <Route path='study/:what' element={
              <Layout>
                <WithPenta>
                  <PentaView />
                </WithPenta>
              </Layout>
            } />
          </Route>


          <Route path='/g/:groupId/*'
            element={context.me === 0 && <Navigate to={`/intro`} />}
          >
            <Route
              index
              element={<>
                <WithGroup>
                  <GroupLayout/>
                </WithGroup>
              </>}
            />
            {/* <Route path='study/:what' element={<WithChats>
              <Layout>
                <WithPenta>
                  <PentaView />
                </WithPenta>
              </Layout>
            </WithChats>} /> */}
          </Route>


          <Route path='/faces/:typeId?'>
            <Route
              index
              element={<>
                <CelebsLayout>
                  <CelebsData fullSrceen={true} />
                </CelebsLayout>
              </>}
            />
          </Route>



          <Route
            path={'/login'}
            element={<>
              <Ad1 />
              {/* <Login>
                <a href='/auth0/login' className="x_ad_cta">
                  Enter
                </a>
              </Login> */}
            </>}
          />



          <Route path="/chats/:chatId/*" element={
            (Boolean(context.me) && context.me !== 0) ? (
              <ChatsAsPage />
            ) : context.me === 0 ? (
              <Ad1Chat />
            ) : null
          } />

          <Route path="/chats/" element={
            (Boolean(context.me) && context.me !== 0) ? (
              <ChatsAsPage />
            ) : context.me === 0 ? (
              <Navigate to="/login" />
            ) : null
          } />

          {/* <Route path="/chats/choose" element={
            context.me ? (
                <Chats />
            ) : (
              <Navigate to="/login" />
            )
          } /> */}

          {/* <Route
            exact path={'/rectificate'}
            element={<>
              <Rectificate />
            </>}
          /> */}

          {/* <Route
            path={'/u/:useravatarId/[?followers,?following]'}
            element={<>
              <Layout peopleShown={false}>
                <WithDOB />
              </Layout>

            </>}
          /> */}

          <Route path='/u/:useravatarId/*'
            // element={context.me === 0 && <Navigate to={`/intro`}></Navigate>}
          >
            {/* {context.me && context.avatars && context.pentas && context.followings && context.followers && */}
            <>
              <Route
                index
                element={<Layout><WithDOB /></Layout>}
              />
              <Route path='video' element={<VideoPop />} />
              <Route path='followers' element={<Layout><WithDOB /></Layout>} />
              <Route path='following' element={<Layout><WithDOB /></Layout>} />
              <Route path='info' element={<Layout><WithDOB /></Layout>} />
              <Route path='settings' element={<Layout><WithDOB /></Layout>} />
              <Route path='study/:what' element={<Layout><WithDOB /></Layout>} />
            </>
            {/* } */}

            {/* {context.summary === 0 && !context.me && <Route element={<Ad1 />} />} */}

          </Route>

          <Route path='/i/:useravatarId/*'
            element={context.me === 0 && <Navigate to={`/intro`} />}
          >
            {Boolean(context.me) &&
              Boolean(context.avatars) && Boolean(context.pentas) && Boolean(context.followings) && Boolean(context.followers) &&
              <>
                <Route
                  index
                  element={<Thumbnail />} />
                <Route path='followers' element={<WithDOB />} />
                <Route path='following' element={<WithDOB />} />
                <Route path='info' element={<WithDOB />} />
              {/* <Route path='study' element={<WithDOB />} /> */}
              <Route path='study/:what' element={<WithDOB />} />
              </>}

            {/* {!context.me && <Route element={<Ad1 />} />} */}

          </Route>



          <Route
            path={'/public/'}
            element={<>

              {/* <WithURLparams> */}
              <WithPublicData />
              {/* </WithURLparams> */}

            </>}
          >
            <Route path='study/:what' element={
              <Layout>
                <WithPenta>
                  <PentaView />
                </WithPenta>
              </Layout>
            } />
          </Route>


          <Route
            path={'/404'}
            element={<><Page404 /></>}
          />





        </Routes>

      <AuthModal />
      <ChatOverlay />
      <InAppBrowserGate />
    </BrowserRouter>
  )
}